/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { TerminalPlatformsEnum } from '../../shared/entities/terminalPlatform';
import { MarkerStylesType, TerminalIconStaticMarkerStyle } from './TerminalIconStaticMarker';

const DefaultTerminalIconStaticMarkerStyle: TerminalIconStaticMarkerStyle = {
  width: '48px',
  height: '48px',
  filter: 'drop-shadow(rgba(20, 29, 36, 0.8) 1px 1px 4px)',
  innerSvgIconProps: {
    viewBox: '0 0 24 24',
    x: '13.25',
    y: '13.25',
    width: '15.5px',
    height: '15.5px',
  },
  divContainerProps: {
    borderRadius: '50%',
  },
  ring1Props: {},
  ring2Props: {
    display: 'none',
  },
  ring3Props: {
    display: 'none',
  },
};

const groundTerminalStyleForTerminalList = {
  ...DefaultTerminalIconStaticMarkerStyle,
  innerSvgIconProps: {
    ...DefaultTerminalIconStaticMarkerStyle.innerSvgIconProps,
    viewBox: '0 0 42 42',
    x: '13.5',
    y: '13.5',
    width: '15px',
    height: '15px',
  },
};

export const TerminalIconStaticMarkerStylesForTerminalList: MarkerStylesType = {
  [TerminalPlatformsEnum.Airborne]: DefaultTerminalIconStaticMarkerStyle,
  [TerminalPlatformsEnum.Maritime]: groundTerminalStyleForTerminalList,
  [TerminalPlatformsEnum.Ground]: groundTerminalStyleForTerminalList,
  [TerminalPlatformsEnum.Fixed]: groundTerminalStyleForTerminalList,
  [TerminalPlatformsEnum.GroundNomadic]: groundTerminalStyleForTerminalList,
  [TerminalPlatformsEnum.SpaceVehicle]: DefaultTerminalIconStaticMarkerStyle,
};

const groundTerminalStyleForMap = {
  ...DefaultTerminalIconStaticMarkerStyle,
  width: '48px',
  height: '48px',
  innerSvgIconProps: {
    viewBox: '0 0 42 42',
    x: '13.5',
    y: '13.5',
    width: '15px',
    height: '15px',
  },
  divContainerProps: {
    marginLeft: '-10px',
    marginTop: '-10px',
    color: '#141D24',
  },
};

export const TerminalIconStaticMarkerStylesForMap: MarkerStylesType = {
  [TerminalPlatformsEnum.Airborne]: {
    ...DefaultTerminalIconStaticMarkerStyle,
    width: '48px',
    height: '48px',
    innerSvgIconProps: {
      ...DefaultTerminalIconStaticMarkerStyle.innerSvgIconProps,
    },
    divContainerProps: {
      marginLeft: '-10px',
      marginTop: '-10px',
      color: '#141D24',
    },
  },
  [TerminalPlatformsEnum.Maritime]: groundTerminalStyleForMap,
  [TerminalPlatformsEnum.Ground]: groundTerminalStyleForMap,
  [TerminalPlatformsEnum.Fixed]: groundTerminalStyleForMap,
  [TerminalPlatformsEnum.GroundNomadic]: groundTerminalStyleForMap,
  [TerminalPlatformsEnum.SpaceVehicle]: {
    ...DefaultTerminalIconStaticMarkerStyle,
    width: '48px',
    height: '48px',
    innerSvgIconProps: {
      ...DefaultTerminalIconStaticMarkerStyle.innerSvgIconProps,
    },
    divContainerProps: {
      marginLeft: '-10px',
      marginTop: '-10px',
      color: '#141D24',
    },
  },
};
